export default __webpack_public_path__ + "static/media/inventor.fa511c9b.svg";